import { ExternalLink, Page } from "../components/ui.jsx";
import { ONBOARDING } from "../data/onboarding.js";
import { CULTURE } from "../data/culture.js";

// First-week page. Steps either navigate in-app (step.page) or open a document
// (step.url), so both shapes render as the same numbered card.
export default function Onboard({ back, go }) {
  const stepBody = (step, i) => (
    <>
      <div className="name">
        <span className="lead">
          <span className="stepnum">{i + 1}</span>
          <span>{step.t}</span>
        </span>
        <span className="arrow">→</span>
      </div>
      <div className="desc">{step.d}</div>
    </>
  );

  const jump = (icon, label, view) => (
    <button className="card" onClick={() => go(view)}>
      <div className="name">
        <span>
          {icon} {label}
        </span>
        <span className="arrow">→</span>
      </div>
    </button>
  );

  return (
    <Page back={back} eyebrow="Start Here" title="Onboarding." intro={ONBOARDING.intro}>
      <div className="vision-block">
        <div className="vlabel">The Vision</div>
        <div className="vtext">{CULTURE.vision}</div>
        <div className="vlabel" style={{ marginTop: 20 }}>
          The Mission
        </div>
        <div className="mtext">“{CULTURE.mission}”</div>
      </div>

      <div className="block">
        <h3>🚀 Your five steps</h3>
        <p>Work these in order — most people finish in a week.</p>
      </div>

      {ONBOARDING.steps.map((step, i) =>
        step.page ? (
          <button key={step.t} className="card" onClick={() => go(step.page)}>
            {stepBody(step, i)}
          </button>
        ) : (
          <ExternalLink key={step.t} id={step.url}>
            {stepBody(step, i)}
          </ExternalLink>
        ),
      )}

      <div className="block" style={{ marginTop: 28 }}>
        <h3>🖤 What we live by</h3>
      </div>
      {ONBOARDING.liveBy.map((item) => (
        <div key={item.h} className="card">
          <div className="name">
            <span>{item.h}</span>
          </div>
          <div className="desc">{item.p}</div>
        </div>
      ))}

      <div className="block" style={{ marginTop: 28 }}>
        <h3>🗺️ Your first-week map</h3>
      </div>
      {jump("🧬", "Who we are → Culture Codes", "culture")}
      {jump("🧭", "Your journey → myTRiBE+", "tribe")}
      {jump("🙌", "Your team → Join the Dream Team", "dreamteam")}
      {jump("🗓️", "The rhythms → myTRiBE Calendar", "calendar")}

      <div className="block" style={{ marginTop: 28 }}>
        <h3>📁 Library</h3>
        <p>The reference copies — read anytime, download if you need paper.</p>
      </div>
      {ONBOARDING.library.map((doc) => (
        <ExternalLink key={doc.title} id={doc.url}>
          <div className="name">
            <span className="lead">
              <span className="libtag">{doc.tag}</span>
              <span>{doc.title}</span>
            </span>
            <span className="arrow">↗</span>
          </div>
        </ExternalLink>
      ))}
    </Page>
  );
}
